//
// Capabilities module - provides the ability to encode capabilities json object into a single integer using bitwise logic
//
//

export const Capabilities = {
    MAIN_UI: 'mainUI',
    MAIN_NAV: 'mainNav',
    SIDE_NAV: 'sideNav',
    VR_INSTRUCTIONS: 'vrInstructions',
    SUPPLEMENTAL_MEDIA_DESKTOP: 'supplementalMediaDesktop',
    NEXT_BUTTON: 'nextButton',
    REGISTRATION: 'registration',
    MAP: 'map',
    GUIDE: 'avatar',
    TOUR_BUTTONS: 'tourButtons',
    INTERACTIVE_ELEMENTS_LIST: 'iEListContainer',
    LOCATION_TITLE: 'locationTitle',
    STOP_TITLE: 'stopTitle',
    OVERFLOW_BUTTON: 'overflowButton',
    TRIGGER_HOVER: 'triggerHover',
    DESKTOP_AUDIO_BUTTON: 'desktopAudioButton',
    DESKTOP_ACCESS_BUTTON: 'desktopAccessButton',
    INFO_MENU_TOUR_BUTTON: 'infoMenuTourButton',
    OVERFLOW_MENU_TOUR_BUTTON: 'overflowMenuTourButton',
    IE_HOVER_EXPAND_HOTSPOT: 'hoverExpandHotspot',
    IE_HOVER_EXPAND_TRIGGER: 'hoverExpandTrigger',
    SCHEDULE_APPLY_BUTTONS: 'scheduleApplyButtons',
    FULL_SCREEN_REG: 'fullScreenReg',
}

/**
 * Array containing all the capabilities available for configuration
 *
 */
const availableCapabilities = [
    {
        key: Capabilities.LOCATION_TITLE,
        bit: Math.pow(2, 0),
    },
    {
        key: Capabilities.STOP_TITLE,
        bit: Math.pow(2, 1),
    },
    {
        key: Capabilities.NEXT_BUTTON,
        bit: Math.pow(2, 2),
    },
    {
        key: Capabilities.INTERACTIVE_ELEMENTS_LIST,
        bit: Math.pow(2, 3),
    },
    {
        key: Capabilities.MAIN_UI,
        bit: Math.pow(2, 4),
    },
    {
        key: Capabilities.MAIN_NAV,
        bit: Math.pow(2, 5),
    },
    {
        key: Capabilities.SIDE_NAV,
        bit: Math.pow(2, 6),
    },
    {
        key: Capabilities.VR_INSTRUCTIONS,
        bit: Math.pow(2, 7),
    },
    {
        key: Capabilities.SUPPLEMENTAL_MEDIA_DESKTOP,
        bit: Math.pow(2, 8),
    },
    {
        key: Capabilities.REGISTRATION,
        bit: Math.pow(2, 9),
    },
    {
        key: Capabilities.GUIDE,
        bit: Math.pow(2, 10),
    },
    {
        key: Capabilities.TOUR_BUTTONS,
        bit: Math.pow(2, 11),
    },
    {
        key: Capabilities.MAP,
        bit: Math.pow(2, 12),
    },
]

/**
 *
 * @param {int} conifgValue
 *
 * Bitwise capabilities config
 */
export const getCapabilityConfig = configValue => {
    const config = {}
    availableCapabilities.map(entry => {
        config[entry.key] = (configValue & entry.bit) > 0
    })
    return config
}

const capabilitiesBitMap = {}
availableCapabilities.map(entry => {
    capabilitiesBitMap[entry.key] = entry.bit
})

export const convertCapabilitiesConfigToValue = config => {
    let value = 0
    // Iterate through the capabilitiesBitMap
    availableCapabilities.map(entry => {
        let k = entry.key
        let b = parseInt(entry.bit) // parseInt just to be safe
        if (config[k]) {
            value += b
        }
    })
    return value
}

export const displayFeatureBasedOnViewportSize = (featureTitle, viewportMeasurement) => {
    const { viewportWidth, viewportHeight } = viewportMeasurement

    switch (featureTitle) {
        case Capabilities.STOP_TITLE:
            return viewportWidth > 10000
        case Capabilities.LOCATION_TITLE:
            return viewportWidth > 254
        case Capabilities.OVERFLOW_BUTTON:
            return viewportWidth > 254
        case Capabilities.TRIGGER_HOVER:
            return viewportWidth > 729
        case Capabilities.HOTSPOT_PREVIEW:
            return viewportWidth > 0
        case Capabilities.NEXT_BUTTON:
            return viewportWidth > 10000
        case Capabilities.TOUR_BUTTONS:
            return viewportWidth > 0
        case Capabilities.DESKTOP_AUDIO_BUTTON:
            return viewportWidth > 254
        case Capabilities.DESKTOP_ACCESS_BUTTON:
            return viewportWidth > 254
        case Capabilities.INFO_MENU_TOUR_BUTTON:
            return viewportWidth > 445
        case Capabilities.OVERFLOW_MENU_TOUR_BUTTON:
            return viewportWidth < 730
        case Capabilities.SCHEDULE_APPLY_BUTTONS:
            return viewportWidth > 729
        case Capabilities.SUPPLEMENTAL_MEDIA_DESKTOP:
            return viewportWidth > 729
        case Capabilities.FULL_SCREEN_REG:
            return viewportHeight <= 660 || viewportWidth <= 886
        default:
            return true
    }
}
